import getConfig from "next/config";

export const useConfig = () => {
    const { publicRuntimeConfig, serverRuntimeConfig } = getConfig();
    return {
        config: publicRuntimeConfig,
        serverConfig: serverRuntimeConfig,
    };
};